import { useEffect, ReactNode } from "react";
import styled from "styled-components";
import { User } from "../../interfaces/User";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useHistory } from "react-router-dom";
import { RootState } from "../../store/rootReducer";
import { getStatusLabel } from "../../store/helpers";
import { useDispatch, useSelector } from "react-redux";
import { getUserAsync, selectUser } from "../../reducers/user/user.actions";
import { PermissionMenuName } from "../../interfaces/UserRole";
// @ts-ignore
import { MUIDataTableMeta } from "mui-datatables";
import Datatables from "../../layouts/Datatables";
import { Tooltip } from '@mui/material';
import Zoom from '@mui/material/Zoom';

export const UserListPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  
  const isLoading = useSelector((state: RootState) => state.user.isLoading);
  const errorMessage = useSelector((state: RootState) => state.user.errorMessage);
  const users = useSelector((state: RootState) => state.user.listUser);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.userControl].ACCESS);

  useEffect(() => {
    dispatch(getUserAsync.request());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editUser = (user: User) => {
    dispatch(selectUser(user));
    history.push(`/user-control/${user.USER_ID}`);
  }
 
  const renderRole = () => {
    if (errorMessage) {
      return (
        // <tr>
        //   <td colSpan={5} style={{textAlign: 'center'}}>
        //     Terdapat kesalahan dalam memuat data:<br/>
        //     <b>{errorMessage}</b>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Terdapat kesalahan dalam memuat data:<br/>
          <b>{errorMessage}</b>
        </div>
      )
    }

    if (isLoading) {
      return (
        // <tr>
        //   <td colSpan={5} style={{textAlign: 'center'}}>
        //     Sedang memuat data &nbsp; <i className="fa fa-refresh fa-spin"></i>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Sedang memuat data &nbsp; <i className="fa fa-refresh fa-spin"></i>
        </div>
      );
    }

    if (users.length === 0) {
      return (
        // <tr>
        //   <td colSpan={5} style={{textAlign: 'center'}}>
        //     Data tidak ditemukan: &nbsp; <button className="btn btn-primary btn-xs">Coba Perbaharui Halaman</button>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Data tidak ditemukan: &nbsp; <button className="btn btn-primary btn-xs">Coba Perbaharui Halaman</button>
        </div>
      );
    }
    
    // return users.map((user) => {
    //   return (
    //     <tr key={user.USER_ID}>
    //       <td>{user.NIK_DETAIL?.EMP_ID || 'undefined'}</td>
    //       <td>{user.NIK_DETAIL?.EMP_NAME || 'undefined'}</td>
    //       <td>{getStatusLabel(user.STATUS) || 'undefined'}</td>
    //       <td>{user.ROLE_DETAIL?.NAME || 'undefined'}</td>
    //       <th>
    //         {user.ROLE_DETAIL.NAME === 'Root Admin' ? (
    //           <button className="btn btn-primary btn-xs" disabled>
    //             <i className="fa fa-edit" aria-hidden="true"></i>
    //           </button>
    //         ): (
    //           <button className="btn btn-primary btn-xs" onClick={() => editUser(user)}>
    //             <i className="fa fa-edit" aria-hidden="true"></i>
    //           </button>
    //         )}
            
    //       </th>
    //     </tr>
    //   );
    // })

    const items = users.map((item, index) => ({
      NO: index + 1,
      id: item.USER_ID,
      STATUS_DESC: getStatusLabel(item.STATUS) || 'undefined',
      USER_NIK: item.NIK_DETAIL?.EMP_ID || 'undefined',
      USER_NAME: item.NIK_DETAIL?.EMP_NAME || 'undefined',
      USER_ROLE: item.ROLE_DETAIL?.NAME || 'undefined',
      ...item,
    }));

    const getHeaderProps = (width: string, padding: string) => {
      return {
        style: {
          width: width,
          maxWidth: width,
          padding: padding
        },
      };
    };

    const getCellProps = (width: string, padding: string, align: string) => {
      return {
        style: {
          width: width,
          maxWidth: width,
          padding: padding,
          fontSize: '12px',
          textAlign: `${align}`
        },
      };
    };

    const actionRenderer = (value: any, tableMeta: MUIDataTableMeta) => {
      const row = items[tableMeta.rowIndex];

      return (
        <div style={{display: 'flex'}}>
          {row.ROLE_DETAIL.NAME === 'Root Admin' ? (
            <button className="btn btn-primary btn-xs" disabled>
              <i className="fa fa-edit" aria-hidden="true"></i>
            </button>
          ): (
            <Tooltip title="Ubah"
              slots={{
                transition: Zoom,
              }} 
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '11px'
                  },
                },
              }}>
              <button className="btn btn-primary btn-xs" onClick={() => editUser(row)}>
                <i className="fa fa-edit" aria-hidden="true"></i>
              </button>
            </Tooltip>
          )}
        </div>
      );
    }

    const columns = [
      {
        name: "USER_NIK",
        label: "ID",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('12%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('12%', '5px 0 5px 10px', 'left')
        },
      },
      {
        name: "USER_NAME",
        label: "Nama Pengguna",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('43%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('43%', '5px 0 5px 10px', 'left')
        }
      },
      {
        name: "STATUS_DESC",
        label: "Status",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('10%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('10%', '5px 0 5px 10px', 'left')
        }
      },
      {
        name: "USER_ROLE",
        label: "Role",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('25%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('25%', '5px 0 5px 10px', 'left')
        }
      },
      { 
        name: "actions",
        label: " ",
        options: {
          filter: false,
          sort: false,
          download: false,
          setCellHeaderProps: () => getHeaderProps('9%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('9%', '5px 0 5px 10px', 'left'),
          customBodyRender: actionRenderer
        },
      }
    ];
    
    return (
      <Datatables data={items} col={columns} title={'Daftar Pengguna Sistem'} />
    )
  }

  return (
    <UserListPageWrapper>
      <section className="content">
        <div className="row">
          <div className="col-lg-6">
            <div className="box">
              <div className="box-header" style={{marginTop: '4px'}}>
                <h3 className="box-title">Daftar Pengguna Sistem</h3>

                <div className="box-tools">
                  { role.create ? (
                    <Link className="btn btn-primary" to="/user-control/create">
                      Buat Pengguna Baru
                    </Link>
                  ) : (
                    <button className="btn btn-primary" disabled>
                      Buat Pengguna Baru
                    </button>
                  ) }
                </div>
              </div>
              {/* <div className="box-body table-responsive no-padding">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nama Pengguna</th>
                      <th>Status</th>
                      <th>Role</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    { renderRole() }
                  </tbody>
                </table>
              </div> */}

              <div style={{padding: '0 10px 10px 10px'}}>
                { renderRole() }
              </div>
            </div>
          </div>
        </div>
      </section>
    </UserListPageWrapper>
  );
};

const UserListPageWrapper = styled.div``;
